import { createApp, nextTick } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { Popup, DatePicker } from 'vant'
import 'vant/lib/index.css'
import store from './store'
import router from './router'
import { scrollToTop, initScrollToTop } from './utils/scroll'

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus)
app.use(store)
app.use(router)

// 注册 Vant 组件
app.use(Popup)
app.use(DatePicker)

// 全局 mixin：处理 fade-in 动画和页面置顶
app.mixin({
  mounted() {
    this.$nextTick(() => {
      // 初始化 fade-in 动画
      this.initFadeInAnimation();
      
      // 确保页面置顶
      if (window.scrollY > 0) {
        scrollToTop();
      }
    });
  },
  methods: {
    initFadeInAnimation() {
      const sections = document.querySelectorAll('.fade-in-section:not(.is-visible)');
      if (sections.length > 0 && 'IntersectionObserver' in window) {
        const observer = new window.IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });

        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const inView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
          if (inView) {
            section.classList.add('is-visible');
          } else {
            observer.observe(section);
          }
        });
      } else if (sections.length > 0) {
        sections.forEach(section => section.classList.add('is-visible'));
      }
    }
  }
});

// 路由守卫：确保页面跳转后置顶
router.afterEach((to, from) => {
  if (from.path !== to.path) {
    // 路由跳转完成后，使用 nextTick 确保 DOM 更新后再滚动
    nextTick(() => {
      scrollToTop();
    });
  }
});

// 初始化页面置顶功能
initScrollToTop();

app.mount('#app')
